import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'

const HERO_BACKGROUND = '58bac4f1ecbfb10ddb007570c96cbfdf.png'

const HeroBanner = () => (
  <section
    className="h-[320px] w-full bg-cover bg-center bg-no-repeat"
    style={{ backgroundImage: `url(${preFixImgUrl(HERO_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col justify-center text-white">
      <LangText
        lngKey="aboutUs.hero.title"
        className="font-smiley-sans text-[40px] font-bold leading-[48px]"
      />
      <LangText
        lngKey="aboutUs.hero.description"
        className="mt-[16px] text-[20px] leading-[28px] text-white/80"
      />
    </div>
  </section>
)

export default HeroBanner
